import { unwrap } from "@majourneys/api-client";
import { api } from "../../../lib/api";

export const homeApi = {
  get: async (lang?: string) =>
    unwrap(await api.home.get({ query: lang ? { lang } : {} })),
};
